import { jsx as _jsx } from "react/jsx-runtime";
import * as Styled from './menu-headline.styles';
export const MenuHeadline = (props) => {
    return _jsx(Styled.MenuHeadline, { "data-xds": "MenuHeadline", ...props });
};
//# sourceMappingURL=menu-headline.js.map